export const DEFAULT_PAGINATION = {
  limit: 15,
  offset: 0,
  page: 1,
};

export const QUERIES_INFO = {
  login: {
    key: 'login',
    endpoint: '/auth/sso/jwt/login',
  },
  currentUser: {
    key: 'current-user',
    endpoint: '/user',
  },
  confirmChangeLoginCurrentUser: {
    key: 'confirm-change-current-user',
    endpoint: '/user/confirmation/[token]',
  },
  getUserJwt: {
    key: 'user-jwt',
    endpoint: '/jwt/auth',
  },
  user: {
    key: 'user',
    endpoint: '/user/[uuid]',
  },
  adminUsers: {
    key: 'admin-users',
    endpoint: '/users',
  },
  adminSetTempPassword: {
    key: 'temporary-password',
    endpoint: '/user/[uuid]/temporary_password',
  },
  samlProviders: {
    key: 'saml-providers',
    endpoint: '/saml/sp',
  },
  samlProvider: {
    key: 'saml-provider',
    endpoint: '/saml/sp/[uuid]',
  },
  oidcProviders: {
    key: 'oidc-providers',
    endpoint: '/oidc/clients',
  },
  oidcProvider: {
    key: 'oidc-provider',
    endpoint: '/oidc/clients/[uuid]',
  },
};

export const MUTATIONS_INFO = {
  logout: '/auth/sso/jwt/logout',
  login: '/auth/sso/jwt/login',
  setPassword: '/user/setpassword',
  requestResetPassword: '/user/request_reset',
  uploadAvatar: '/user/[uuid]/avatar_upload',
  blockUser: '/user/blocking/[uuid]',
  unblockUser: '/user/unblocking/[uuid]',
  adminUserChangeEmail: '/user/[uuid]/email',
  impersonation: '/auth/sso/jwt/impersonation',
  deimpersonation: '/auth/sso/jwt/deimpersonation',
  samlProvider: '/saml/sp/[uuid]',
  serviceProviderResetKeyPair: '/saml/sp/[uuid]/reset_sp_keypair',
  resetIdpKeyPair: '/saml/sp/[uuid]/reset_idp_keypair',
  totpGenerate: '/user/totp/generate',
  totpVerify: '/user/totp/verify',
  reserveCodesGenerate: '/user/reserve_code',
  currentUserUpdate: '/user',
  requestToApplyNewLoginCurrentUser: '/user/email',
  oidcProvider: '/oidc/clients/[uuid]',
};

export const DEFAULT_LOCALE = 'en-EN';

export const API_PATH = '/web_api/v1';

export const SERVICE_PROVIDER_TYPES = {
  oidc: 'oidc',
  saml: 'saml',
} as const;
